const BASE_URL = process.env.REACT_APP_BASE_URL

// AUTH ENDPOINTS
export const endpoints = {
    SIGNUP_API: BASE_URL + "/auth/signup",
    LOGIN_API: BASE_URL + "/auth/login",
    RESETPASSTOKEN_API: BASE_URL + "/auth/reset-password-token",
    RESETPASSWORD_API: BASE_URL + "/auth/reset-password",
  }

  // PROFILE ENDPOINTS
export const profileEndpoints = {
    GET_USER_DETAILS_API: BASE_URL + "/profile/getUserDetails",
    GET_ALL_USERS : BASE_URL + "/profile/showAllStudent"
  }


  // BOOK ENDPOINTS
export const bookEndpoints = {
    GET_ALL_BOOK_API: BASE_URL + "/book/getAllBook",
    CREATE_BOOK_API: BASE_URL + "/book/createBook",
    GET_ALL_CATEGORY_API :BASE_URL + "/book/showAllCategories",
    CREATE_CATEGORY_API :BASE_URL + "/book/createCategory",
    CATEGORYPAGEDATA_API: BASE_URL + "/book/getCategoryPageDetails",


    ISSUED_BOOK_API : BASE_URL + "/book/issuedBook",
    RETURN_ISSUED_BOOK_API : BASE_URL + "/book/returnBook"


   }

   export const categoryEndpoints = {
    // CREATE_CATEGORY_API :BASE_URL + "/book/getCategoryPageDetails",

   }
  
  // SETTINGS PAGE API
export const settingsEndpoints = {
    UPDATE_DISPLAY_PICTURE_API: BASE_URL + "/profile/updateDisplayPicture",
    UPDATE_PROFILE_API: BASE_URL + "/profile/updateProfile", 
    CHANGE_PASSWORD_API: BASE_URL + "/auth/changepassword",
     }

     //BOOK ISSUED API

     export const issuedBookendpoints = {
        ISSUED_BOOK_API: BASE_URL + "/book/issuedBook",
        GET_ALL_ISSUED_BOOK_API: BASE_URL + "/book/getAllIssuedBook",
        GET_ALL_ISSUED_BOOK_REPORT_API: BASE_URL + "/book/getAllIssuedBookReport",

        RETURN_ISSUED_BOOK: BASE_URL + "/book/returnBook",
     }